/**
 * Display label for the product shown in the global activation progress widget.
 * Peripheral (camera / adapter) activation is branded "OnStar activation" in the
 * card title, matching Figma:
 * https://www.figma.com/design/fImtcuBL0OIx4Qsfnamr5d/GA-Cameras---Devices?node-id=5832-162571
 */
export const ONSTAR_PRODUCT_NAME = 'OnStar';

/**
 * Lifecycle of a peripheral activation batch, driven by the
 * `/peripherals/.../activate` call and `/batch-statuses/{id}` polling.
 */
export const ActivationBatchStatus = {
  /** Activation requested / batch still processing. */
  IN_PROGRESS: 'in-progress',
  /** Batch finished (may include per-device failures). */
  COMPLETED: 'completed',
  /** Batch could not start or failed wholesale. */
  FAILED: 'failed',
} as const;

export type ActivationBatchStatus =
  (typeof ActivationBatchStatus)[keyof typeof ActivationBatchStatus];

/**
 * Terminal result of a batch, used to drive the completion toasts.
 * `failed` is true for a wholesale failure (could not start / no successes).
 */
export type ActivationCompletionResult = {
  total: number;
  success: number;
  failure: number;
  failed: boolean;
};
